import DarkModeOutlinedIcon from "@mui/icons-material/DarkModeOutlined";
import LightModeOutlinedIcon from "@mui/icons-material/LightModeOutlined";
import Avatar from "@mui/material/Avatar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import { useState } from "react";
import { type TokenClaims } from "../../core/auth/auth";
import { useThemeMode } from "../../core/theme/themeContext";
import UserMenu from "./UserMenu";

interface TopbarProps {
  claims: TokenClaims;
}

const Topbar = ({ claims }: TopbarProps) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const { mode, toggleMode } = useThemeMode();
  const initial = claims.name.charAt(0).toUpperCase();

  return (
    <Box
      component="header"
      sx={{
        height: 64,
        display: "flex",
        alignItems: "center",
        px: 3,
        bgcolor: "var(--color-surface)",
        borderBottom: "1px solid var(--color-border)",
        flexShrink: 0,
      }}
    >
      <Toolbar disableGutters sx={{ width: "100%", minHeight: "unset !important", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "baseline", gap: 1.5 }}>
          <Box component="span" sx={{ fontSize: 38, fontWeight: 700, letterSpacing: "-0.5px", fontFamily: "'Yrsa', Georgia, serif" }}>
            tg<Box component="span" sx={{ color: "var(--color-accent)" }}>c</Box>
          </Box>
          <Box component="span" sx={{ fontSize: 28, color: "var(--color-text-secondary)", fontWeight: 400 }}>
            —
          </Box>
          <Box component="span" sx={{ fontSize: 28, color: "var(--color-text-secondary)", fontWeight: 400 }}>
            Tax & Governance Compliance
          </Box>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <Tooltip title={mode === "dark" ? "Modo claro" : "Modo oscuro"}>
            <IconButton onClick={toggleMode} size="small" sx={{ color: "var(--color-text-secondary)" }}>
              {mode === "dark" ? <LightModeOutlinedIcon /> : <DarkModeOutlinedIcon />}
            </IconButton>
          </Tooltip>
          <IconButton onClick={(e) => setAnchorEl(e.currentTarget)} size="small">
          <Avatar
            sx={{
              width: 34,
              height: 34,
              fontSize: 14,
              fontWeight: 600,
              bgcolor: "var(--color-accent)",
            }}
          >
            {initial}
          </Avatar>
        </IconButton>

          <UserMenu anchorEl={anchorEl} onClose={() => setAnchorEl(null)} claims={claims} />
        </Box>
      </Toolbar>
    </Box>
  );
};

export default Topbar;
